import { GeographicInfoCountry } from "@/Common/Models/Localization/GeographicInfoCountry";
import { MedfarDictionariesValidationHelper } from "@/ContactDirectory/Helpers/MedfarDictionariesValidationHelper";
import { DirectoryFaxNumber } from "@/ContactDirectory/Models//DirectoryFaxNumber";
import { DirectoryPhoneNumber } from "@/ContactDirectory/Models//DirectoryPhoneNumber";
import { DirectoryAddressValidator } from "./DirectoryAddressValidator";

export abstract class BaseContactDirectoryValidator {
    protected validationRules: MedfarDictionariesValidationHelper;
    protected addressValidator: DirectoryAddressValidator;
    protected countries: { [id: string]: GeographicInfoCountry } = {};

    public constructor(validationHelper: MedfarDictionariesValidationHelper, countries: GeographicInfoCountry[]) {
        this.validationRules = validationHelper;
        this.addressValidator = new DirectoryAddressValidator(validationHelper);
        this.countries = countries.toDictionary(p => p.Id);
    }

    protected isNumberValid(phone: DirectoryPhoneNumber | DirectoryFaxNumber): boolean {
        return !!phone?.countryId
            && !!phone?.number
            && this.validationRules.validatePhoneNumber(phone.number, phone.countryId);
    }
}
